<style scoped>
</style>

<template>
  <div class="section border border-1 border-dark pt-2 pb-2 ps-2">
    <span>
      <button class="btn btn-sm btn-primary" @click="settingForCamera.panelOpened = !settingForCamera.panelOpened">
        <i class="fa fa-bars"></i>
      </button>
      <h2 class="ms-2 section-header">カメラ設定</h2>
      <a class="ms-2 ext-link" target="_blank" href="https://scrapbox.io/mhrise-queque/camera"><i class="fas fa-question-circle"></i></a>
    </span>
    <CollapseTransition class="mt-2 ps-4">
      <div v-show="settingForCamera.panelOpened">
        <label>
          <input type="checkbox" v-model="settingForCamera.videoDeviceEnabled" v-on:change="onVideoDeviceEnabledChange()">
          <span class="ms-1">ブラウザのカメラとしてキャプチャボードを接続する</span>
        </label>
        <div class="ms-4">
          <button class="btn btn-sm btn-primary"
            v-bind:class="{ 'btn-secondary': ! settingForCamera.videoDeviceEnabled}"
            v-on:click="onRequestPermission"
            >カメラを接続</button>
          <VideoDeviceSelect ref="videoDeviceSelect"
            v-model="settingForCamera.videoDeviceId"
            v-bind:enabled="settingForCamera.videoDeviceEnabled" />
          <GameScreen ref="gameScreen"
            v-model="settingForCamera.videoDeviceId"
            v-bind:enabled="settingForCamera.videoDeviceEnabled"
            v-on:update-status="onUpdateStatus"
            v-on:start-quest="onStartQuest"
            v-on:return-quest="onReturnQuest" />
          <div>
            カメラ画像認識結果
            <div class="ms-4">
              <span>{{inLobby ? '⭕' : '❌'}}</span><span class="ms-1">ロビー</span><br>
              <span>{{inQuest ? '⭕' : '❌'}}</span><span class="ms-1">クエスト</span><br>
              <span>{{infoDisplayOnRightSide ? '⭕' : '❌'}}</span><span class="ms-1">画面右側に情報を表示中</span><br>
            </div>
          </div>
          <div>
            状態
            <div class="ms-4">
              <span>モード: </span><span class="ms-2">{{toolModeText}}</span>
            </div>
          </div>
        </div>
      </div>
    </CollapseTransition>
    <!--
    <pre>{{$props}}</pre>
    <pre>{{$data}}</pre>
    -->
  </div>
</template>

<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition"
import GameScreen        from '@/components/parts/GameScreen'
import VideoDevice       from '@/components/resource/VideoDevice'
import VideoDeviceSelect from '@/components/parts/VideoDeviceSelect'

export default {
  components: {
    CollapseTransition,
    VideoDeviceSelect,
    GameScreen,
  },
  props: {
    settingForCamera: { type: Object, required: true, },
  },
  computed: {
    toolModeText() {
      if (this.toolMode == 'lobby') return 'ロビーモード'
      if (this.toolMode == 'quest') return 'クエストモード'
      return ''
    },
  },
  data() {
    return {
      toolMode: '',
      inLobby: false,
      inQuest: false,
      infoDisplayOnRightSide: false,
    }
  },
  methods: {
    onVideoDeviceEnabledChange() {
      if (this.settingForCamera.videoDeviceEnabled) {
        VideoDevice.queryPermissionAsync().then(state => {
          if (state != 'granted') return
          
          this.$refs.videoDeviceSelect.open(this.videoDeviceId)
          this.$refs.gameScreen.open()
        })
      }
      else {
        this.$refs.videoDeviceSelect.close()
        this.$refs.gameScreen.close()
      }

      this.$emit('change', this.settingForCamera)
    },
    onRequestPermission() {
      if (! this.settingForCamera.videoDeviceEnabled) return

      VideoDevice.requestPermissionAsync().then(() => {
        this.$refs.videoDeviceSelect.open()
      })
    },
    onUpdateStatus(status) {
      this.inLobby = status.inLobby
      this.inQuest = status.inQuest
      this.infoDisplayOnRightSide = status.infoDisplayOnRightSide

      if (! this.toolMode) {
        if (this.inLobby) this.toolMode = 'lobby'
        if (this.inQuest) this.toolMode = 'quest'
      }

      this.$emit('update-camera-status', status)
    },
    onStartQuest() {
      this.toolMode = 'quest'
      this.$emit('start-quest')
    },
    onReturnQuest() {
      this.toolMode = 'lobby'
      this.$emit('return-quest')
    },
  },
}
</script>
